export const stripTime = (d: Date): Date => {
  const res = new Date(d.getTime());
  res.setHours(0, 0, 0, 0);
  return res;
};

export const getToday = (): Date => {
  return stripTime(new Date());
};

export const dateToLocalString = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const parseSelectableDate = (d?: string): Date | undefined => {
  if (!d) return undefined;
  const parsed = new Date(d);
  return stripTime(parsed);
};

export const clampDate = (d: Date, min?: Date, max?: Date): Date => {
  const time = d.getTime();
  const minT = min ? stripTime(min).getTime() : undefined;
  const maxT = max ? stripTime(max).getTime() : undefined;
  const clamped = new Date(
    minT !== undefined && time < minT ? minT : maxT !== undefined && time > maxT ? maxT : time
  );
  return stripTime(clamped);
};

export const isBefore = (a: Date, b: Date): boolean => {
  return stripTime(a).getTime() < stripTime(b).getTime();
};

export const isSameOrAfter = (a: Date, b: Date): boolean => {
  return stripTime(a).getTime() >= stripTime(b).getTime();
};